import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../component-library/button';

const PageNotFound = () => {
	const navigate = useNavigate();

	return (
		<>
			<div className="padding-vertical-40">
				<h1>
					404:
					<br />
					Page Not Found
				</h1>
				<p className="large-text margin-bottom-32">The page you were looking for could not be found.</p>
				<Button
					type="secondary"
					label="Visit Our Home Page"
					onClick={() => navigate('/')}
				/>
			</div>
		</>
	);
};

export default PageNotFound;
